import {
  LocalShipping,
  LocalShippingTwoTone,
  DepartureBoardTwoTone,
} from "@mui/icons-material";
import {
  Box,
  Chip,
  Collapse,
  Divider,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { impexDateFormat } from "../manager/dateManager";
import { getUser } from "../services/authService";
import "./card-invoice.css";

const InvoiceCard = ({
  invoice,
  handleInvoiceOpen,
  active,
  notify,
  notifyCaroDelay,
}) => {
  const [openList, setOpenList] = useState(false);

  const user = getUser();

  const handleCollapse = () => {
    setOpenList(!openList);
  };
 
  return (
    <>
      <Box
        sx={{
          borderRadius: "10px",
          padding: "8px",
          background: "#ffffff",
          cursor: "pointer",
          ...(active === invoice?.InvoiceDocLink && {
            border: "1px solid blue",
          }),
        
        }}
        onClick={() => {
          handleInvoiceOpen(invoice?.InvoiceDocLink);
          handleCollapse();
        }}
      >
        <Box
          sx={{
            padding: "3px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="p"
              color={"#44596c"}
              letterSpacing={"1px"}
              textTransform={"uppercase"}
              fontSize={"17px"}
              fontWeight={500}
            >
              {invoice?.InvoiceNo}
            </Typography>
            <Box sx={{ textAlign: "right" }}>
              <Box sx={{display:"flex", flexDirection:"column"}}>
              {invoice?.CargoReadyDate && (
                <Tooltip title="Cargo Ready Date">
                <Chip
                  variant="outlined"
                  label={impexDateFormat(invoice?.CargoReadyDate)}
                  icon={<LocalShipping sx={{fontSize:"15px" }}/>}
                  color={"success"}
                  sx={{ mb: 0.5, fontSize:"12px", px: 2 }}
                />
                </Tooltip>
              )}

              {invoice?.CargoDelayedDate && (
                 <Tooltip title="Cargo Delayed Date">
                <Chip
                  variant="outlined"
                  label={impexDateFormat(invoice?.CargoDelayedDate)}
                  icon={<DepartureBoardTwoTone sx={{fontSize:"15px" }}/>}
                  color={"error"}
                  
                  sx={{ mb: 0.5 , fontSize:"10px" }}
                />
                </Tooltip>
              )}
              </Box>

              {!invoice?.CargoReadyDate &&
                (user?.isSupplierOperation || user?.isSupplierAdmin) && (
                  <>
                    <Tooltip title="Inform Cargo Ready">
                      <IconButton
                        sx={{
                          mr: 1,
                          border: "2px solid #6DBF45",
                          borderRadius: "50%",
                        }}
                        onClick={() =>
                          notify(invoice?.SupplierInvoiceDocumentsID)
                        }
                      >
                        <LocalShippingTwoTone
                          style={{
                            color: "#6DBF45",
                            fontSize:"15px"
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              {!invoice?.CargoReadyDate && !invoice?.CargoDelayedDate  &&
                (user?.isSupplierOperation || user?.isSupplierAdmin) && (
                  <Tooltip title="Inform Cargo Delay">
                    <IconButton
                      sx={{
                        border: "2px solid #BD3039",
                        borderRadius: "50%",
                      }}
                      onClick={() => {
                        notifyCaroDelay(invoice?.SupplierInvoiceDocumentsID);
                      }}
                    >
                      <DepartureBoardTwoTone
                        style={{
                          color: "#BD3039",
                          fontSize:"15px"
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
            </Box>
          </Box>
          <Collapse in={openList} timeout="auto" unmountOnExit>
            <Divider
              sx={{
                borderStyle: "dashed",
                borderBottomWidth: "medium",
                mt: 2,
              }}
            />
            <Box
              sx={{
                textTransform: "uppercase",
                display: "flex",
                justifyContent: "space-between",
                padding: "4px",
                fontSize: "14px",
                fontWeight: "600",
                backgroundColor: "#eff4ff",
                color: "#3266ff",
              }}
            >
              <p className="product">PART</p>
              <p className="unit">QTY.</p>
              <p className="price">PRICE</p>
            </Box>
            <Divider
              sx={{
                borderStyle: "dashed",
                borderBottomWidth: "medium",
              }}
            />
            {invoice?.AllParts?.map((part) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px 0px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#758193",
                  }}
                >
                  <p className="product">{part.PartNo}</p>
                  <p className="unit">{part.InvoiceQty}</p>
                  <p className="price">{part.PartPrice}</p>
                </Box>
              );
            })}
            <Divider
              sx={{
                borderStyle: "dashed",
                borderBottomWidth: "medium",
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "5px 0px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#758193",
              }}
            >
              <p className="product">Invoice amount</p>
              <p className="unit"></p>
              <p className="price">{invoice?.InvoiceAmount}</p>
            </Box>
          </Collapse>
        </Box>
      </Box>
    </>
  );
};

export default InvoiceCard;
